/***
 * File name: flattenFeilds.js
 *
 * Program Description:
 * This file contains a javascript function that flatten deeply nested objects
 *
 */
const flattenFields = (fields) => {
  return fields.flatMap((x) => {
    let v = [x]
    if (x.children) {
      v = v.concat(flattenFields(x.children))
    }
    return v
  })
}
export default flattenFields
